module.exports = __webpack_public_path__ + "img/header-diamondJewelrySets.912432d.jpg";